export default "__VITE_ASSET__BDBhKolv__"